import api from 'services/api'

export interface AsaasConfig {
	configured: boolean
	accountId?: string
	walletId?: string
	webhookId?: string
	hasWebhookAuthToken?: boolean
	apiKeyPreview?: string
	billingDefaults?: {
		interestPercentage?: number
		finePercentage?: number
		daysAfterDueDateToRegistrationCancellation?: number
		daysToDueDate?: number
	}
}

export interface SaveAsaasConfigPayload {
	accountId?: string
	apiKey?: string
	walletId?: string
	createWebhook?: boolean
	interestPercentage?: number
	finePercentage?: number
	daysAfterDueDateToRegistrationCancellation?: number
	daysToDueDate?: number
}

export class AsaasRepository {
	async getClinicConfig(): Promise<AsaasConfig> {
		const response = await api.get('/asaas/clinic/config')
		return response.data.asaas
	}

	async saveClinicConfig(payload: SaveAsaasConfigPayload) {
		const response = await api.patch('/asaas/clinic/config', payload)
		return response.data.asaas
	}

	async generateBoleto(
		paymentId: string,
		billTo?: 'patient' | 'responsible'
	) {
		const response = await api.post(
			`/payments/${paymentId}/asaas/boleto`,
			billTo ? { billTo } : {}
		)
		return response.data.payment
	}
}
